// extracted by mini-css-extract-plugin
export var cell = "_53-4";
export var headerCell = "_53-2";
export var rowHeader = "_53-3";
export var table = "_53-1";
export var tableContainer = "_53-0";